/* eslint-disable */
import MainCard from "components/MainCard";
import { useEffect, useState } from "react";
import ECharts from 'echarts-for-react';
import { useTheme } from "components/ThemeContext";

const chartDataInit = {
  tooltip: {
    trigger: 'item',
    formatter: '{b} : {c} ({d}%)'
  },
  legend: {
    orient: 'vertical',
    left: 'left',
    textStyle : {
      color : '#000'
    },
  },
  series: [
    {
      name: '',
      type: 'pie',
      radius: '80%',
      data: [],
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      }
    }
  ]
}

export function PieChart({pieDatas, subwayCode='', widthSize=480, legendColor="#fff", legendPosition="left"}) {
  // const [chartDatas, setChartDatas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState(chartDataInit);
  const { mode } = useTheme();

  useEffect(()=>{
    // console.log(pieDatas)
    if (pieDatas && pieDatas.length > 0) {
      let optionsCopy = {...chartDataInit};
      // let chartDataCopy = JSON.parse(JSON.stringify(pieDataSample));
      let chartDataCopy = JSON.parse(JSON.stringify(optionsCopy));
      let use
      pieDatas && pieDatas.map(function(pie, k) {
        // chartDataCopy.options.labels.push(pie.title);
        // chartDataCopy.series.push(pie.cnt);
        if (pie.link !== null) {
          chartDataCopy.series[0].data.push({ value: pie.cnt, name: pie.title, link : pie.link, label:{ position :'inside'}, labelLine : { show:false} });
        } else {
          chartDataCopy.series[0].data.push({ value: pie.cnt, name: pie.title, label:{ position :'inside'}, labelLine : { show:false} });
        }
      })
      chartDataCopy.legend.textStyle.color = (mode === 'white' ? "#000" : "#fff");
      chartDataCopy.legend.left = legendPosition;
      // console.log(chartDataCopy)
      setOptions(chartDataCopy);
      // setChartDatas(chartDataCopy);
      setIsLoading(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  // },[pieDatas, isLoading]);
  },[pieDatas, isLoading, mode]);

  // 클릭 이벤트 핸들러
  const onChartClick = (params) => {
    if (params.data.link) {
      window.open(params.data.link, '_self');
    }
  };

  if (isLoading) {
    return (
      <div className="mixed-chart mixed-chart1">
        <MainCard content={false}>
            <ECharts
              option={options}
              opts={{ renderer: 'svg', width: widthSize+'px', height: '270px' }}
              onEvents={{
                click: onChartClick,
              }}
            />
        </MainCard>
      </div>
    )
  }
}

export default PieChart;
